export const NAME_COLUMN_WIDTH = 45;
